import React from 'react';
import { getVisiblePageNumbers } from '../utils/pagination';

function GridPagination({
  page,
  pages,
  onPageChange,
  size,
  ulClassName = '',
  wrapperClassName = 'd-flex justify-content-center',
  prevLabel = 'Previous',
  nextLabel = 'Next',
  'aria-label': ariaLabel = 'Grid pagination',
}) {
  if (pages <= 1) {
    return null;
  }

  const visiblePages = getVisiblePageNumbers(page, pages, 5);
  const paginationClass = size ? `pagination pagination-${size}` : 'pagination';

  const nav = (
    <nav aria-label={ariaLabel}>
      <ul className={`${paginationClass}${ulClassName ? ` ${ulClassName}` : ''}`}>
        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
          >
            {prevLabel}
          </button>
        </li>

        {visiblePages.map((pageNumber) => (
          <li key={pageNumber} className={`page-item ${pageNumber === page ? 'active' : ''}`}>
            <button type="button" className="page-link" onClick={() => onPageChange(pageNumber)}>
              {pageNumber}
            </button>
          </li>
        ))}

        <li className={`page-item ${page === pages ? 'disabled' : ''}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(page + 1)}
            disabled={page === pages}
          >
            {nextLabel}
          </button>
        </li>
      </ul>
    </nav>
  );

  if (!wrapperClassName) {
    return nav;
  }

  return <div className={wrapperClassName}>{nav}</div>;
}

export default GridPagination;
